export default function b64toBlob(base64, type = "application/pdf") {
  return fetch(`data:${type};base64, ${base64}`).then((res) => res.blob());
}
